import React from 'react';
import { Loader2 } from 'lucide-react';

interface GoogleLoginButtonProps {
    isLoading: boolean;
    onClick: () => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ isLoading, onClick }) => {
    return (
        <div className="w-full space-y-3 mb-4">
            <button
                onClick={onClick}
                disabled={isLoading}
                className="w-full h-12 bg-white hover:bg-gray-50 text-gray-900 rounded-xl flex items-center justify-center gap-2.5 transition-all
        hover:scale-[1.01] hover:shadow-[0_0_20px_rgba(255,255,255,0.1)]
        active:scale-[0.98] font-sans font-semibold text-sm shadow-lg disabled:opacity-70 disabled:cursor-not-allowed group relative overflow-hidden"
            >
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary-100/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                {isLoading ? (
                    <>
                        <Loader2 className="w-4 h-4 animate-spin text-primary-600" />
                        <span className="animate-pulse text-xs font-medium text-gray-500">Connecting...</span>
                    </>
                ) : (
                    <>
                        <img
                            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                            alt="Google"
                            className="w-4 h-4"
                        />
                        <span className="text-sm">Continue with Google</span>
                    </>
                )}
            </button>

            <p className="text-[10px] text-primary-200/40 font-sans tracking-wide text-center">
                Secure authentication powered by <span className="text-primary-300/60 font-medium">Google OAuth 2.0</span>
            </p>
        </div>
    );
};

export default GoogleLoginButton;
